<template>
  <el-list-item  @click="handleClick">
    <div class="achievement-item">
      <h3>{{ achievement.projectName }}</h3>
      <p>{{ achievement.projectIntroduction }}</p>
      <div class="achievement-meta">
        <span>领域: {{ achievement.category }}</span>
        <span>状态: {{ achievement.projectProgress }}</span>
      </div>
    </div>
  </el-list-item>
</template>

<script>
export default {
  name: 'AchievementItem',
  props: {
    // 科研成果对象
    achievement: {
      type: Object,
      required: true,
    }
  },
  methods: {
    // 处理点击事件，跳转到详情页
    handleClick() {
      this.$router.push({
        name: 'AchievementDetail',
        params: { id: this.achievement.id }
      });
    }
  }
};
</script>

<style scoped>
.achievement-item {
  padding: 15px 0;
  border-bottom: 1px dashed #eee;
  /* 添加浅灰色边框 */
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 15px;
  background-color: #fff;
}

.achievement-item h3 {
  margin: 0 0 10px 0;
  color: #333;
}

.achievement-item p {
  color: #666;
  line-height: 1.6;
  margin: 0 0 10px 0;
}

.achievement-meta {
  margin-top: 10px;
  display: flex;
  gap: 20px;
  color: #999;
  font-size: 14px;
}
</style>
    